import { 
    CreateReferralCodeDto,
    CreateReferralDto, 
    GetReferralCodeDto, 
    GetReferralDto, 
    MessageResponseDto, 
    ReferralApiFp,
    ReferralControllerGet200Response,
    ReferralControllerGetReferralCode200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseReferralModel = ReferralControllerGet200Response;
export type GetResponseReferralCodeModel = ReferralControllerGetReferralCode200Response;
export type GetReferralModel = GetReferralDto;
export type GetReferralCodeModel = GetReferralCodeDto;
export type MutateResponseReferralModel = MessageResponseDto;
export type CreateReferralModel = CreateReferralDto;
export type CreateReferralCodeModel = CreateReferralCodeDto;
// export type UpdateReferralModel = EditReferralDto;
// export type DeleteReferralModel = DeleteReferralDto;

export const apiReferralFp = ReferralApiFp(apiConfig);
export const getReferralController = apiReferralFp.referralControllerGet;
export const getReferralCodeController = apiReferralFp.referralControllerGetReferralCode;
export const createReferralController = apiReferralFp.referralControllerCreate;
export const createReferralCodeController = apiReferralFp.referralControllerCreateReferralCode;
// export const updateReferralController = apiReferralFp.referralControllerEdit;
// export const deleteReferralController = apiReferralFp.referralControllerDelete;

export const QueryKeyReferral = QueryKey.Referral;
export const QueryKeyReferralCode = QueryKey.ReferralCode;
